import cache from '@/plugins/cache'
import { defineStore } from 'pinia'

const useIaaStore = defineStore(
  'iaa',
  {
    state: () => ({
		ostype: cache.session.get('iaa-ostype') ? cache.session.get('iaa-ostype') : 1,//默认竖屏，2横屏
		isweb: cache.session.get('isweb') ? cache.session.get('isweb') : 0,//1web端，0微端
		isTest: cache.session.get('iaa-istest') ? cache.session.get('iaa-istest') : '',
		secretParams: cache.session.get('iaa-secret-params') ? cache.session.get('iaa-secret-params') : '',
		isRefresh: cache.session.get('iaa-isrefresh') || '',//要刷新的指定路由
		isAdLucky: cache.session.get('isadLucky') || 0,//幸运礼包广告观看成功
		isAdSuccess: cache.session.get('isadSuccess') || 0,//广告观看成功自动抽奖
    }),
    actions: {
		// 刷新
		setRefresh(data) {
			this.isRefresh = data;
			cache.session.set('isRefresh',data)
		},
		// 幸运礼包广告观看成功
		setAdLucky(data) {
			return new Promise((resolve, reject) => {
				this.isAdLucky = data;
				cache.session.set('isadLucky',data)
				resolve()
			})
		},
		// 广告看成功自动抽奖
		setAdSuccess(data) {
			return new Promise((resolve, reject) => {
				this.isAdSuccess = data;
				cache.session.set('isadSuccess',data)
				resolve()
			})
		},
		clearSecretParams(){
			return new Promise((resolve, reject) => {
				this.secretParams = ''
				cache.session.remove('iaa-secret-params');
				resolve()
			})
		},
		setSecretParams(val){
			return new Promise((resolve, reject) => {
				this.secretParams = val
				cache.session.set('iaa-secret-params', val);
				resolve()
			})
		},
		setIsTest(val){
			return new Promise((resolve, reject) => {
				this.isTest = val
				cache.session.set('iaa-istest', val);
				resolve()
			})
		},
		// 存微端信息
		setIsweb(data) {
		    return new Promise((resolve, reject) => {
				this.isweb = data;
				cache.session.set('isweb',data)
				resolve()
		    })
		},
		setOstype(val){
			return new Promise((resolve, reject) => {
				this.ostype = val
				cache.session.set('iaa-ostype', val);
				resolve()
			})
		}
    }
  })
  
export default useIaaStore
